import { Skeleton } from '@mui/material';

export function ImagesContainerPlaceholder() {
  return (
    <div className="flex flex-1 flex-col items-center" style={containerStyle}>
      <div className="flex flex-col items-end gap-3">
        <Skeleton variant="rectangular" sx={buttonSx} />
        <Skeleton variant="rectangular" sx={imageSx} />
      </div>
    </div>
  );
}

////
const containerStyle = {
  minHeight: '568px',
};

const buttonSx = {
  alignSelf: 'flex-end',
  width: '120px',
  height: '34px',
  borderRadius: '17px',
};

const imageSx = {
  maxWidth: '430px',
  minWidth: '430px',
  height: '430px',
  borderRadius: '20px',
  filter: 'brightness(0.95)',
};
